import {
  OnlineOrder,
  OrderingApi,
  OnlineOrderingStore,
  ResultResponse
} from 'kiolyn-api';
import IOnlineOrderingRepository from '../domain/repositories/IOnlineOrderingRepository';

export default class OnlineOrderingRepository
  implements IOnlineOrderingRepository {
  private readonly api: OrderingApi;
  private readonly basePath: string;

  constructor(basePath: string) {
    this.basePath = basePath;
    this.api = new OrderingApi({
      basePath
    });
  }

  public async listStore(): Promise<OnlineOrderingStore[]> {
    return (await this.api.listPublishedStores()).data;
  }

  public async loadStore(storeid: string): Promise<OnlineOrderingStore> {
    return (await this.api.loadPublishedStore(storeid)).data;
  }

  public async submitOrder(
    storeid: string,
    order: OnlineOrder,
    token: string
  ): Promise<ResultResponse> {
    return (await this.api.submitOrder(storeid, token, order)).data;
  }

  public getWebsocketForSubmitOrder(
    storeId: string,
    orderId: string
  ): EventSource {
    return new EventSource(
      `${this.basePath}/app/ordering/${storeId}/order-sync/${orderId}`
    );
  }

  public async checkOrderStatus(
    storeId: string,
    orderUniqueId: string
  ): Promise<boolean> {
    return (await this.api.checkOrderStatus(storeId, orderUniqueId)).data;
  }

  public async loadOrder(
    storeId: string,
    orderId: string
  ): Promise<OnlineOrder> {
    return (await this.api.loadOrder(storeId, orderId)).data;
  }

  public async loadOrderForAppleWallet(
    storeId: string,
    orderId: string
  ): Promise<OnlineOrder> {
    return (await this.api.loadOrderForAppleWallet(orderId, storeId)).data;
  }

  public async submitAppleWallet(
    storeId: string,
    orderId: string,
    data: { token: string; number: string }
  ) {
    return (await this.api.payWithAppleWallet(orderId, storeId, data)).data;
  }
}
